// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1b8KQ","empty":"ModalGraph_empty__2DbBt"};